module.exports = __webpack_public_path__ + "static/img/preson_bg.ab6571a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/preson_bg.png
// module id = MzxU
// module chunks = 0